export default __webpack_public_path__ + "b94bc4bb052f2dad0ec3b7b647dde049.png";